<template>
  <div :id="this.$route.name">
    <form @submit.prevent="this.$ValidForm(this)"></form>
    <div class="card text-center">
      <div class="card-header" :class="ThemeTitleModal">
        <ul
          class="nav nav-tabs mt-3 card-header-tabs"
          id="myTab"
          role="tablist"
          dir="rtl"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              id="Detail-tab"
              data-toggle="tab"
              href="#TanzimatAsli"
              role="TanzimatAsli"
              aria-controls="TanzimatAsli"
              aria-selected="true"
              >تنظیمات اصلی</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              id="SematForUser-tab"
              data-toggle="tab"
              href="#SematForUser"
              role="tab"
              aria-controls="SematForUser"
              aria-selected="true"
              >انتساب سمت به کاربر</a
            >
          </li>
        </ul>
      </div>
      <div class="tab-content" id="Controler">
        <div
          class="tab-pane fade show active"
          id="TanzimatAsli"
          role="TanzimatAsli"
          aria-labelledby="Detail-tab"
        >
          <div id="Controler">
            <div class="container mt-3 mb-3 text-right">
              <div class="row">
                <div class="col-lg-8 col-12">
                  <div class="row">
                    <div class="col-lg-6 col-12">
                      <div class="mt-3">
                        <span>شماره کاربری</span>
                        <input
                          type="text"
                          class="form-control InputText required"
                          v-model="DataAxios.UserCode"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6 col-12 text-right">
                      <div class="mt-3">
                        <span>نام کاربری داشبورد</span>
                        <input
                          type="text"
                          class="form-control InputText required"
                          v-model="DataAxios.UserNameDashBoard"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6 col-12">
                      <div class="mt-3">
                        <span>کد کاربری </span>
                        <input
                          type="text"
                          class="form-control InputText required"
                          v-model="DataAxios.UserName"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6 col-12 text-right">
                      <div class="mt-3">
                        <span>کلمه عبور</span>
                        <input
                          type="password"
                          class="form-control InputText required"
                          v-model="DataAxios.Pss"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6 col-12">
                      <div class="mt-3">
                        <span>مشخصات کاربر</span>
                        <input
                          type="text"
                          class="form-control InputText required"
                          v-model="DataAxios.NamFam"
                        />
                      </div>
                    </div>
                    <div class="col-lg-6 col-12 text-right">
                      <div class="mt-3">
                        <span>کد ملی</span>
                        <input
                          type="text"
                          maxlength="10"
                          @input="$CheckupLengthCodeMeli($event)"
                          class="form-control InputText required required-CodeMeli"
                          v-model="DataAxios.UserCodeMeli"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-12 text-right">
                  <div class="mt-3">
                    <vue-upload-multiple-image
                      :dragText="TitleUploaderLogo"
                      :browseText="ClearDescriptionUploaderLogo"
                      :primaryText="InfoUploaderLogo"
                      :popupText="DtlInfoUploaderLogo"
                      :multiple="MultipleImaegs"
                      @upload-success="uploadImageSuccess"
                      @before-remove="beforeRemove"
                      @edit-image="editImage"
                      :data-images="images"
                    ></vue-upload-multiple-image>
                  </div>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-lg-4 col-12">
                  <span>شماره موبایل کاربر</span>
                  <input
                    type="text"
                    class="form-control InputText"
                    v-model="DataAxios.UserMobile"
                  />
                </div>
                <div class="col-lg-4 col-12 text-right">
                  <span>مخفف جهت چاپ</span>
                  <input
                    type="text"
                    class="form-control InputText"
                    v-model="DataAxios.MoxafafJahateChap"
                  />
                </div>
                <div class="col-lg-4 col-12 text-right">
                  <span>شماره پرسنلی</span>
                  <input
                    type="text"
                    class="form-control InputText"
                    v-model.number="DataAxios.UserCustomerCode"
                  />
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-4 col-12 text-right">
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input InputText"
                        id="Rahbari"
                        @click="statusChk($event)"
                        :value="Rahbari"
                      />
                      <label class="custom-control-label" for="Rahbari"
                        >راهبر سیستم</label
                      >
                    </div>
                  </span>
                </div>
                <div class="col-lg-4 col-12 text-right">
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input InputText"
                        id="Modir"
                        @click="statusChk($event)"
                        :value="Modir"
                      />
                      <label class="custom-control-label" for="Modir"
                        >مدیر سیستم</label
                      >
                    </div>
                  </span>
                </div>
                <div class="col-lg-4 col-12 text-right">
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input InputText"
                        id="Disable"
                        @click="statusChk($event)"
                        :value="DisableUser"
                      />
                      <label class="custom-control-label" for="Disable"
                        >غیرفعال کردن کاربر</label
                      >
                    </div>
                  </span>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button-edit-data
                    class="mb-3 mr-2"
                    :DataParanet="DataAxios"
                  ></button-edit-data>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade show p-2"
          id="SematForUser"
          role="tab"
          aria-labelledby="SematForUser-tab"
        >
          <div class="alert alert-secondary mt-2 mb-2 text">
            <span> انتساب سمت به کاربر </span>
            <span class="text-danger font-weight-bold">
              [ {{ DataAxios.NamFam }} ]
            </span>
            <span> به کد کاربری </span>
            <span class="text-danger font-weight-bold">
              [ {{ DataAxios.UserCode }} ]
            </span>
          </div>
          <div v-if="this.$store.state.TarifKarbaran.EditMode == false">
            <div dir="rtl" class="text-right mt-3 mb-3">
              <button
                type="button"
                class="btn btn-success mr-1"
                dir="ltr"
                data-toggle="collapse"
                href="#collapseAddSemat"
                role="button"
                aria-expanded="false"
                aria-controls="collapseAddSemat"
              >
                <span class="mr-2" @click.prevent="Add"> افزودن سمت </span>
                <span class="fa fa-plus"></span>
              </button>
            </div>
            <div
              id="collapseAddSemat"
              class="alert alert-secondary p-1 mb-2 collapse"
            >
              <div class="row mt-3">
                <div class="col-md-8 col-12">
                  <select
                    id="GrpDb"
                    class="form-control mt-2 mb-2"
                    v-model="ListSematha"
                  >
                    <option value="-1">
                      <span>یک سمت برای کاربر انتخاب کنید</span>
                    </option>
                    <option
                      :value="item.id"
                      v-for="item in this.$store.state.TarifKarbaran.Sematha"
                      :id="item.id"
                      :key="item.id"
                    >
                      <span>{{ item.GName }}</span>
                    </option>
                  </select>
                </div>
                <div class="col-md-4 col-12">
                  <div
                    class="pl-2 mt-2 text-right animate__animated animate__fadeInDown"
                  >
                    <button
                      id="SeveData"
                      type="submit"
                      class="btn btn-success mr-1 w-100"
                      dir="ltr"
                      @click.prevent="SetDeta"
                    >
                      <span class="mr-2"> ثبت اطلاعات </span>
                      <span class="fa fa fa-check"></span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-lg-4 col-12 text-right">
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input InputText"
                        id="Asli"
                        @click="statusChk($event)"
                        :value="DisableUser"
                      />
                      <label class="custom-control-label" for="Asli"
                        >اصلی</label
                      >
                    </div>
                  </span>
                </div>
                <div class="col-lg-4 col-12 text-right">
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input InputText"
                        id="UserForSystem"
                        @click="statusChk($event)"
                        :value="DisableUser"
                      />
                      <label class="custom-control-label" for="UserForSystem"
                        >سیستم های خودکار</label
                      >
                    </div>
                  </span>
                </div>
                <div class="col-lg-4 col-12 text-right">
                  <span class="form-control p-1">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input InputText"
                        id="IsArchive"
                        @click="statusChk($event)"
                        :value="DisableUser"
                      />
                      <label class="custom-control-label" for="IsArchive"
                        >بایگانی سمت</label
                      >
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="this.$store.state.TarifKarbaran.EditMode == true"
            class="alert alert-warning p-1 mb-2"
          >
            <div>
              <span>ویرایش سمت کاربری</span>
              <span class="text-danger"
                >[
                {{ this.$store.state.TarifKarbaran.EditDataUserGrp.Post }}
                ]</span
              >
            </div>
            <div class="row mt-3">
              <div class="col-md-8 col-12">
                <select
                  id="GrpDb"
                  class="form-control mt-2 mb-2"
                  v-model="EditDataUserGrp"
                >
                  <option value="-1">
                    <span>یک سمت برای کاربر انتخاب کنید</span>
                  </option>
                  <option
                    :value="item.id"
                    v-for="item in this.$store.state.TarifKarbaran.Sematha"
                    :id="item.id"
                    :key="item.id"
                  >
                    <span>{{ item.GName }}</span>
                  </option>
                </select>
              </div>
              <div class="col-md-4 col-12">
                <div
                  class="pl-2 mt-2 text-right animate__animated animate__fadeInDown"
                >
                  <button
                    id="SaveEditData"
                    type="submit"
                    class="btn btn-danger mr-1 w-100"
                    dir="ltr"
                    @click.prevent="SetEditDeta"
                  >
                    <span class="mr-2"> ویرایش اطلاعات </span>
                    <span class="fa fa fa-check"></span>
                  </button>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-lg-4 col-12 text-right">
                <span class="form-control p-1">
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input InputText"
                      id="AsliEdit"
                      @click="statusChk($event)"
                      :checked="
                        this.$store.state.TarifKarbaran.EditDataUserGrp.Asli
                      "
                    />
                    <label class="custom-control-label" for="AsliEdit"
                      >اصلی</label
                    >
                  </div>
                </span>
              </div>
              <div class="col-lg-4 col-12 text-right">
                <span class="form-control p-1">
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input InputText"
                      id="UserForSystemEdit"
                      @click="statusChk($event)"
                      :value="UserForSystem"
                      :checked="
                        this.$store.state.TarifKarbaran.EditDataUserGrp
                          .UserForSystem
                      "
                    />
                    <label class="custom-control-label" for="UserForSystemEdit"
                      >استفاده برای سیستم های خودکار</label
                    >
                  </div>
                </span>
              </div>
              <div class="col-lg-4 col-12 text-right">
                <span class="form-control p-1">
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input InputText"
                      id="IsArchiveEdit"
                      @click="statusChk($event)"
                      :value="IsArchive"
                      :checked="
                        this.$store.state.TarifKarbaran.EditDataUserGrp
                          .IsArchive
                      "
                    />
                    <label class="custom-control-label" for="IsArchiveEdit"
                      >بایگانی سمت</label
                    >
                  </div>
                </span>
              </div>
            </div>
          </div>
          <asing-grid
            v-if="this.$store.state.renderComponentGridOneToMeny"
            :DataRowGrid="this.$store.state.TarifKarbaran.UserGrp"
            :DatacolumnsGrid="this.$store.state.TarifKarbaran.ColumnsUser"
          ></asing-grid>
          <!-- <assign-grid v-if="this.$store.state.renderComponentGridOneToMeny" :DataRowGrid="this.$store.state.TarifSematha.DataGrpDb" :Data="DataAxios">  </assign-grid> -->
        </div>
      </div>
      <div v-for="Dataa in EditData" :key="Dataa.id"></div>
    </div>
  </div>
</template>
<script>
import VueUploadMultipleImage from "vue-upload-multiple-image";
import AsingGrid from "../Tools/AsingGrid.vue";
import ButtonEditData from "../Tools/ButtonEditData.vue";
// import AssignGrid from '../Tools/AssignGrid.vue'
export default {
  components: { VueUploadMultipleImage, ButtonEditData, AsingGrid },
  data() {
    return {
      images: [],
      TitleUploaderLogo: "بارگذاری عکس کاربری",
      ClearDescriptionUploaderLogo: "",
      InfoUploaderLogo: " بارگذاری موفق",
      DtlInfoUploaderLogo:
        "برای مشاهده عکس کاربر بارگذاری شده بر روی عکس لوگو کلیک کنید",
      MultipleImaegs: false,
      Theme: "bg-BlueGreen",
      DataAxios: null,
      EditData: this.$store.state.TarifKarbaran.EditData,
      DataSematha: null,
      DaraAxios_GetSematha: {
        ArryfildValue: {},
        Method: "Get",
        Action: "TarifSematha",
        Token: this.$session.get("Token"),
      },
      DataAxios_PostUserData: {
        ArryfildValue: this.$store.state.TarifKarbaran.DataUserGrp,
        Method: "Post",
        Action: "TarifKarbaran/b_AddRowUserGrp",
        Token: this.$session.get("Token"),
      },
      DataAxios_PutUserGrp: {
        ArryfildValue: null,
        Method: "Put",
        Action: this.$route.name + "/b_UpdateUserGrp",
        Token: this.$session.get("Token"),
      },
      DataAxios_ColumnsUserGrp: {
        ArryfildValue: {
          SoftwareId: 2,
          UserId: 1,
          FormName: "frmUserGrp",
          ShowView: 0,
        },
        Method: "post",
        Action: "ReadGridColumns",
      },
      DataAxios_GridRowUserGrp: {
        ArryfildValue: { Id: null },
        Method: "Get",
        Action: this.$route.name + "/GetUserGrp",
        Token: this.$session.get("Token"),
      },
      RowGridUserGrp: null,
    };
  },
  computed: {
    ThemeTitleModal() {
      return this.$store.state.ThemeModal;
    },
    Rahbari: {
      get() {
        return this.$store.state.TarifKarbaran.Data[0].IsAdministrator;
      },
      set(value) {
        this.$store.state.TarifKarbaran.Data[0].IsAdministrator = value;
      },
    },
    Modir: {
      get() {
        return this.$store.state.TarifKarbaran.Data[0].IsUserAdmin;
      },
      set(value) {
        this.$store.state.TarifKarbaran.Data[0].IsUserAdmin = value;
      },
    },
    DisableUser: {
      get() {
        return this.$store.state.TarifKarbaran.Data[0].Archive;
      },
      set(value) {
        this.$store.state.TarifKarbaran.Data[0].Archive = value;
      },
    },
    ListSematha: {
      get() {
        return this.$store.state.TarifKarbaran.Sematha.id;
      },
      set(value) {
        //تکمیل اطلاعات برای اضافه کردن UserGrp
        this.$store.state.TarifKarbaran.DataUserGrp.TblGrpId = value;
      },
    },
    //---EditModeCheckBox--
    // UserForSystem:{
    //     get(){

    //         return this.$store.state.TarifKarbaran.EditDataUserGrp.UserForSystem;
    //     },
    //     set(value){
    //         //تکمیل اطلاعات برای اضافه کردن UserGrp
    //         this.$store.state.TarifKarbaran.EditDataUserGrp.UserForSystem=value;
    //     }
    // },
    // Asli:{
    //     get(){
    //         console.log(this.$store.state.TarifKarbaran.EditDataUserGrp.Asli);
    //         return this.$store.state.TarifKarbaran.EditDataUserGrp.Asli;
    //     },
    //     set(value){
    //         //تکمیل اطلاعات برای اضافه کردن UserGrp
    //         this.$store.state.TarifKarbaran.EditDataUserGrp.Asli=value;
    //     }
    // },
    // IsArchive:{
    //     get(){

    //         return this.$store.state.TarifKarbaran.EditDataUserGrp.IsArchive;
    //     },
    //     set(value){
    //         //تکمیل اطلاعات برای اضافه کردن UserGrp
    //         this.$store.state.TarifKarbaran.EditDataUserGrp.IsArchive=value;
    //     }
    // },
    //---EditModeCheckBox---
    EditDataUserGrp: {
      get() {
        return this.$store.state.TarifKarbaran.EditDataUserGrp.TblGrpId;
      },
      set(value) {
        //تکمیل اطلاعات برای اضافه کردن UserGrp
        this.$store.state.TarifKarbaran.EditDataUserGrp.TblGrpId = value;
      },
    },
  },
  methods: {
    beforeRemove(done) {
      // var r = confirm("remove image")
      // if (r == true) {
      //     done()
      // }
      this.$swal({
        title: "حذف عکس کاربر",
        text: "از حذف عکس اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "حذف شود",
        cancelButtonText: "انصراف",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal({
            title: "حذف موفق",
            text: "عکس کاربری با موفقیت انجام شد",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "تایید",
          });
          done();
        }
      });
    },

    statusChk: function (event) {
      var targetId = event.currentTarget.id;
      var checkBox = document.getElementById(targetId);
      if (checkBox.id == "Rahbari") {
        if (checkBox.checked == true) {
          this.$store.state.TarifKarbaran.Data[0].IsAdministrator = true;
        } else {
          this.$store.state.TarifKarbaran.Data[0].IsAdministrator = false;
        }
      }
      if (checkBox.id == "Modir") {
        if (checkBox.checked == true) {
          this.$store.state.TarifKarbaran.Data[0].IsUserAdmin = true;
        } else {
          this.$store.state.TarifKarbaran.Data[0].IsUserAdmin = false;
        }
      }
      if (checkBox.id == "Disable") {
        if (checkBox.checked == true) {
          this.$store.state.TarifKarbaran.Data[0].Archive = true;
        } else {
          this.$store.state.TarifKarbaran.Data[0].Archive = false;
        }
      }
      //------------------------Tab2----------------------------
      if (checkBox.id == "UserForSystem") {
        if (checkBox.checked == true) {
          this.$store.state.TarifKarbaran.DataUserGrp.UserForSystem = true;
        } else {
          this.$store.state.TarifKarbaran.DataUserGrp.UserForSystem = false;
        }
      }
      if (checkBox.id == "Asli") {
        if (checkBox.checked == true) {
          this.$store.state.TarifKarbaran.DataUserGrp.Asli = true;
        } else {
          this.$store.state.TarifKarbaran.DataUserGrp.Asli = false;
        }
      }
      if (checkBox.id == "IsArchive") {
        if (checkBox.checked == true) {
          this.$store.state.TarifKarbaran.DataUserGrp.IsArchive = true;
        } else {
          this.$store.state.TarifKarbaran.DataUserGrp.IsArchive = false;
        }
      }
      //-------------------------Tab2--EditMod--------------------
      if (checkBox.id == "UserForSystemEdit") {
        if (checkBox.checked == true) {
          this.$store.state.TarifKarbaran.EditDataUserGrp.UserForSystem = true;
        } else {
          this.$store.state.TarifKarbaran.EditDataUserGrp.UserForSystem = false;
        }
      }
      if (checkBox.id == "AsliEdit") {
        if (checkBox.checked == true) {
          this.$store.state.TarifKarbaran.EditDataUserGrp.Asli = true;
        } else {
          this.$store.state.TarifKarbaran.EditDataUserGrp.Asli = false;
        }
      }
      if (checkBox.id == "IsArchiveEdit") {
        if (checkBox.checked == true) {
          this.$store.state.TarifKarbaran.EditDataUserGrp.IsArchive = true;
        } else {
          this.$store.state.TarifKarbaran.EditDataUserGrp.IsArchive = false;
        }
      }
    },
    SetDeta() {
      this.$PostData(this.DataAxios_PostUserData)
        .then((data) => {
          if (data == "Ok") {
            this.$mySweetDefault(
              "ثبت موفق",
              "سمت انتخاب شده با موفقیت به کاربر اختصاص داده شد",
              "success",
              2000
            );
            this.$store.state.renderComponent = false;
            this.$store.state.renderComponentGridOneToMeny = false;
            this.$nextTick(() => {
              this.$store.state.renderComponent = true;
              this.$store.state.renderComponentGridOneToMeny = true;
            });
          }
        })
        .catch((data) => {
          console.log("data", data);
        });
    },
    Asli() {
      if (this.$store.state.TarifKarbaran.EditDataUserGrp.Asli == true) {
        return "Checked";
      }
    },
    IsArchive() {
      if (this.$store.state.TarifKarbaran.EditDataUserGrp.IsArchive == true) {
        return "Checked";
      }
    },
    UserForSystem() {
      if (
        this.$store.state.TarifKarbaran.EditDataUserGrp.UserForSystem == true
      ) {
        return "Checked";
      }
    },
    SetEditDeta() {
      this.$store.state.TarifKarbaran.EditDataUserGrp.ZamanLastEdit = "454545";
      this.$store.state.TarifKarbaran.EditDataUserGrp.InfoDes = "Test";
      this.$store.state.TarifKarbaran.EditDataUserGrp.ZamanLastEdit = "545454";
      this.$store.state.TarifKarbaran.EditDataUserGrp.ZamanInsert = "545454";
      this.DataAxios_PutUserGrp.ArryfildValue =
        this.$store.state.TarifKarbaran.EditDataUserGrp;
      this.$PostData(this.DataAxios_PutUserGrp).then((data) => {
        if (data.status == "Ok") {
          this.$store.state.renderComponent = false;
          this.$store.state.renderComponentGridOneToMeny = false;
          this.$nextTick(() => {
            this.$store.state.renderComponent = true;
            this.$store.state.renderComponentGridOneToMeny = true;
          });
          this.$mySweetDefault(
            "عملیات موفق",
            "ویرایش اطلاعات با موفقیت انجام شد",
            "success",
            7000
          );
        } else {
          this.$mySweetDefault(
            "خطایی رخ داده!",
            "در ویرایش اطلاعات خطایی رخ داده ،لطفا کمی بعد تلاش کنید و در صورت مشاهده  دوباره ، خطا را به پشتیبانی اطلاع دهید",
            "error",
            2000
          );
        }
      });
    },
  },
  mounted() {},
  created() {
    let info;
    let list = [];
    for (let index = 0; index < this.EditData.length; index++) {
      info = this.EditData[index];
      list.push(info);
    }
    this.DataAxios = list[0];
  },
};
</script>
<style scoped>
.bg-DefModal {
  background: #566787;
}
#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #fff;
}

.bg-warning,
.alert-warning,
.label-warning {
  background-color: #ffc10778 !important;
}
.btn-success {
  background: #67b221 !important;
  border: 1px solid #5ea31e !important;
}
.form-control {
  text-align: center;
}
</style>
